import React from 'react';
import SignUpContainer from '../../containers/SignUp/SignUpContainer';

function SignUpPageRoute() : JSX.Element {
  return <SignUpContainer type="SignUp" />;
}

export default SignUpPageRoute;
